import { IdResource } from "../../../../constants/IdResource";
export var checkIsResourcePremiumDogTreat = function (path) { return function (action, state$, dependencies) {
    return action.resourceId === IdResource.DogtreatPremium ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/inventory/checks/checkIsResourcePremiumDogTreat.ts
// module id = 1907
// module chunks = 3